<template>
  <div class="header">
    <div class="div_logo">
      <router-link
        to="/home"
        class="logo"
        aria-label
      >
        <img
          src="/official_mobile/static/img/home/logo.png"
          alt="logo"
        >
      </router-link>
      <a
        href="https://access.gaminglabs.com/Certificate/Index?i=277"
        aria-label
        target="_blank"
        class="caming"
      >
        <img
          src="/official_mobile/static/img/home/caming.jpg"
          alt="game"
        >
      </a>

      <div class="icon">
        <a
          target="_blank"
          href="https://www.facebook.com/pppoker123"
        >
          <img
            src="/official_mobile/static/img/home/facebook.png"
            alt="facebook"
          >
        </a>
        <a
          target="_blank"
          href="https://www.instagram.com/pppokerglobal"
        >
          <img
            src="/official_mobile/static/img/home/ins.png"
            alt="ins"
          >
        </a>
        <a
          target="_blank"
          href="https://www.youtube.com/channel/UCpklAxJQBUEoFISwCn9o4jg?view_as=subscriber"
        >
          <img
            src="/official_mobile/static/img/home/youtube.png"
            alt="youtube"
          >
        </a>
      </div>
    </div>
    <img
      src="/official_mobile/static/img/home/menu.png"
      alt="menu-logo"
      class="menu-logo"
      @click="showPopup"
    >

    <van-popup
      v-model="show"
      position="right"
      :style="{ height: '100%' }"
      class="popup-slider"
    >
      <div>
        <img
          class="close_btn"
          src="/official_mobile/static/img/home/close.png"
          @click="show = false"
        >
        <div class="slider-item">
          <p
            class="contact"
            @click="toAbout"
          >
            <img src="/official_mobile/static/img/home/contact_us.png"><a>{{
              $t("common.p21")
            }}</a>
          </p>
        </div>
        <div class="slider-item">
          <p
            class="contact"
            @click="toKnight"
          >
            <a>PP KNIGHT</a>
          </p>
        </div>
        <div class="slider-item">
          <lang-select />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
// @ is an alias to /src
import LangSelect from "./LangSelect.vue";

export default {
  components: {
    LangSelect,
  },
  data() {
    return {
      show: false,
      // popover: false
    };
  },
  // computed: {
  //   activeIndex () {
  //     return this.$store.state.tab
  //   }
  // },
  methods: {
    showPopup() {
      this.show = true;
    },
    toAbout() {
      this.show = false;
      this.$router.push({ name: "about" });
    },
    toKnight() {
      this.show = false;
      window.open("https://pppoker.net/ppknight/", "_blank");
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
  position: relative;
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
  height: 110px;
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  background-color: #000;
  .div_logo {
    position: relative;
    top: 30px;
    left: 0px;
  }
  .logo {
    margin-left: 40px;
    display: inline-block;
    vertical-align: top;
    img {
      width: 222px;
      display: inline-block;
    }
  }
  .caming {
    vertical-align: top;
    margin-left: 38px;
    display: inline-block;
    img {
      width: 90px;
      margin-top: 6px;
      display: inline-block;
    }
  }
  .menu-logo {
    position: absolute;
    // margin: 20px 40px 20px 0px;
    right: 40px;
    top: 38px;
    // margin-bottom: 40px;
    display: inline-block;
    width: 58px;
  }
  .popup-slider {
    background-color: rgba(0, 0, 0, 0.8);
    width: 80%;
    height: 100%;
    // margin-top: 110px;
    .close_btn {
      display: block;
      width: 34px;
      margin: 30px 50px;
    }
    .slider-item {
      padding: 30px 50px;
      color: #dadada;
      font-size: 32px;
      border-top: 2px solid #3c3c3c;
      // border-top: 2px solid #fff;
      a {
        color: #dadada;
      }
      .contact {
        display: flex;
        align-items: center;
        img {
          width: 39px;
          margin-right: 10px;
          vertical-align: middle;
          display: inline-block;
        }
      }
    }
  }
}

.icon {
  display: inline-block;
  margin-left: 40px;
  a {
    margin: 0 10px;
    display: inline-block;
    img {
      height: 40px;
      display: block;
    }
  }
}
</style>
